import { Tab, Tabs, Paper } from '@mui/material';
import React from 'react';
import { ASPENDENTAL_FONTS } from '../../../constants/constant';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';

var TAGTabs = function TAGTabs(_ref) {
  var activeTab = _ref.activeTab,
      elevated = _ref.elevated,
      setActiveTab = _ref.setActiveTab,
      tabs = _ref.tabs,
      tabTheme = _ref.tabTheme;

  var handleChange = function handleChange(event, newValue) {
    event.preventDefault();
    setActiveTab(Number(newValue));
  };

  return React.createElement(Paper, {
    elevation: elevated ? 4 : 0
  }, React.createElement(Tabs, {
    variant: "fullWidth",
    value: tabs[activeTab],
    onChange: handleChange,
    "aria-label": "icon label tabs example",
    centered: true,
    sx: {
      backgroundColor: elevated ? 'backgrounds.neutral' : 'white',
      '& .MuiTab-root': {
        borderBottom: !elevated ? '2px solid' : 'none',
        borderColor: !elevated ? 'neutrals.primary' : 'none'
      },
      '& .MuiTab-root:hover': {
        backgroundColor: elevated ? 'neutrals.primary' : 'neutrals.neutral'
      },
      '& .MuiTab-textColorPrimary:active': {
        color: 'secondary.main'
      },
      '& .MuiTab-textColorPrimary.Mui-selected': ASPENDENTAL_FONTS.tabActive,
      '& .MuiTabs-indicator': {
        backgroundColor: 'secondary.main'
      }
    }
  }, tabTheme === 'TextOnly' && tabs.map(function (tab) {
    return React.createElement(Tab, {
      sx: ASPENDENTAL_FONTS.tabRegular,
      key: tab.tabText,
      label: tab.tabText
    });
  }), tabTheme === 'IconOnly' && tabs.map(function (tab) {
    return React.createElement(Tab, {
      sx: ASPENDENTAL_FONTS.tabRegular,
      key: tab.tabText,
      icon: React.createElement(TAGSvgIcon, {
        icon: tab.iconName
      })
    });
  }), tabTheme === 'TextAndIcon' && tabs.map(function (tab) {
    return React.createElement(Tab, {
      sx: ASPENDENTAL_FONTS.tabRegular,
      key: tab.tabText,
      icon: React.createElement(TAGSvgIcon, {
        icon: tab.iconName
      }),
      label: tab.tabText
    });
  })));
};

export default TAGTabs;